import { User } from '../user/User.model';

export class ActivityTargetsByUserInDateSelectedResponse {
    user: Array<User>;

    constructor(data: Array<User>){
        this.user=data;
    }
}
